"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createTracker: () => createTracker,
  getTracker: () => getTracker,
  trackEvent: () => trackEvent,
  trackPageView: () => trackPageView,
  trackSearch: () => trackSearch,
  trackSearchClick: () => trackSearchClick
});
module.exports = __toCommonJS(src_exports);
var import_behavioral_analytics_tracker_core = require("@elastic/behavioral-analytics-tracker-core");
var sharedTracker = null;
function getSharedTracker() {
  if (sharedTracker === null) {
    throw new Error("Behavioral Analytics: Tracker not initialized.");
  }
  return sharedTracker;
}
function createTracker(options) {
  sharedTracker = new import_behavioral_analytics_tracker_core.Tracker(options);
  return sharedTracker;
}
function getTracker() {
  return getSharedTracker();
}
function trackEvent(eventType, properties) {
  var _a;
  return (_a = getSharedTracker()) == null ? void 0 : _a.trackEvent(eventType, properties);
}
function trackPageView(properties) {
  var _a;
  return (_a = getSharedTracker()) == null ? void 0 : _a.trackPageView(properties);
}
function trackSearch(properties) {
  var _a;
  return (_a = getSharedTracker()) == null ? void 0 : _a.trackSearch(properties);
}
function trackSearchClick(properties) {
  var _a;
  return (_a = getSharedTracker()) == null ? void 0 : _a.trackSearchClick(properties);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  createTracker,
  getTracker,
  trackEvent,
  trackPageView,
  trackSearch,
  trackSearchClick
});
//# sourceMappingURL=index.cjs.map